export const REDUCER_KEY = "videos";
export const SET_VIDEO_DETAILS = "SET_VIDEO_DETAILS";
